import { render, staticRenderFns } from "./BuildingConfigShowDetailsCard.vue?vue&type=template&id=5e5d6458"
import script from "./BuildingConfigShowDetailsCard.vue?vue&type=script&lang=ts"
export * from "./BuildingConfigShowDetailsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports